import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { PaymentVerifierTailwind } from '../components/PaymentVerifierTailwind';

const VerifyPaymentPage: React.FC = () => {
  const [verificationResult, setVerificationResult] = useState<any>(null);
  const [transactionId, setTransactionId] = useState<string | null>(null);
  
  useEffect(() => {
    // Obtener ID de transacción de parámetros URL
    const params = new URLSearchParams(window.location.search);
    const txId = params.get('txid') || params.get('payment_id') || params.get('id');
    
    if (txId) {
      setTransactionId(txId);
    }
  }, []);
  
  const handleVerificationComplete = (result: any) => {
    console.log('Verificación completada:', result);
    setVerificationResult(result);
  };
  
  return (
    <div className="container mx-auto px-4 py-8">
      <div className="flex flex-col space-y-6">
        <div className="p-6 bg-gray-800 rounded-lg shadow-md border border-gray-700">
          <h1 className="text-2xl font-bold mb-4 text-center text-white">
            Verificación de Pago
          </h1>
          
          <p className="text-md text-center text-gray-400 mb-6">
            Verifica el estado de tu pago con Payku utilizando el ID de la transacción
          </p>
          
          <div className="border-t border-gray-700 my-4"></div>
          
          <PaymentVerifierTailwind 
            initialTransactionId={transactionId || undefined}
            onVerificationComplete={handleVerificationComplete}
            showForm={true}
          />
          
          {verificationResult && verificationResult.success && (
            <div className="mt-6 p-4 bg-green-900/30 rounded-md flex flex-col items-center text-center">
              <svg className="w-10 h-10 text-green-500 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
              </svg>
              <h3 className="text-lg font-bold mb-1 text-green-400">
                ¡Pago verificado correctamente!
              </h3>
              <p className="text-gray-300 max-w-sm">
                Tu pago ha sido verificado y procesado. Si compraste monedas, ya deberían estar disponibles en tu cuenta.
              </p>
            </div>
          )}
          
          <div className="border-t border-gray-700 my-6"></div>
          
          <div className="flex justify-between mt-4">
            <Link 
              to="/dashboard" 
              className="inline-flex items-center px-4 py-2 border border-gray-600 rounded-md text-white hover:bg-gray-700 transition-colors"
            >
              <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"></path>
              </svg>
              Volver al Dashboard
            </Link>
            
            <Link 
              to="/coins" 
              className="inline-flex items-center px-4 py-2 bg-blue-600 hover:bg-blue-700 rounded-md text-white transition-colors"
            >
              Comprar monedas
              <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3"></path>
              </svg>
            </Link>
          </div>
        </div>
        
        <div className="p-5 bg-gray-800 rounded-lg shadow-sm border border-gray-700">
          <h3 className="text-lg font-bold mb-3 text-white">
            ¿Problemas con la verificación?
          </h3>
          
          <p className="text-sm text-gray-400 mb-4">
            Si tienes problemas para verificar tu pago, puedes intentar estas opciones:
          </p>
          
          <div className="flex flex-col space-y-3">
            <p className="text-sm text-gray-300">
              1. Asegúrate de que el ID de la transacción es correcto. Debe tener el formato: <code className="bg-gray-700 px-1 rounded">trxXXXXXXXXXX</code>.
            </p>
            <p className="text-sm text-gray-300">
              2. Si acabas de realizar el pago, espera unos minutos antes de verificar.
            </p>
            <p className="text-sm text-gray-300">
              3. Revisa tu correo electrónico para ver si has recibido la confirmación de pago.
            </p>
            <p className="text-sm text-gray-300">
              4. Si necesitas ayuda, contacta a nuestro soporte en <Link to="/support" className="text-blue-400 underline">la página de soporte</Link>.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerifyPaymentPage; 